// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planboard-holder[data-v-f3c7c77a] {\n  position: relative;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
